import { stringifyUrl } from "query-string";
import React, { useMemo } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { avatarsApi } from "../../utils/constants";

interface Props extends RouteComponentProps<{}> {}

const PlansSuccess: React.FC<Props> = ({ location }) => {
  const history = useHistory();

  const message = useMemo(() => {
    const state: any = location?.state;

    const message = state?.message;

    if (message) return message;

    return "You have successfully upgraded your plan. Go to your workspace and check it out!";
  }, [location.state]);

  return (
    <div className="flex flex-col w-full items-center overflow-y-auto overflow-x-hidden pb-10">
      <div className="flex flex-col justify-center w-full max-w-7xl mx-auto px-4">
        <div className="flex w-full flex-col items-center mt-4">
          <img
            className="h-24 w-24 sm:h-32 sm:w-32 z-10"
            src={stringifyUrl({
              url: `${avatarsApi}/bottts/11SCSL6sZXLKHm66dhh4zCtQgkBwuvd5123iYABKW81R9xKvjeJ.svg`,
              query: { w: 128, h: 128 }
            })}
            alt="Hotspot avatar"
          />
          <span className="font-bold text-xl sm:text-3xl mt-3 mb-5">
            SUCCESS!
          </span>
          <span className="text-sm mb-2 sm:mb-5">{message}</span>
          <button
            onClick={() => history.push("/workspace/settings/billing")}
            className="w-full sm:w-3/12 text-xs text-white py-2 mt-4 shadow rounded-md outline-none transition-all bg-hotspotty-400 border-hotspotty-400 hover:bg-hotspotty-400 focus:outline-none"
          >
            Go to Workspace
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlansSuccess;
